import React from 'react';

import Icon from 'Components/Icon';

export default [
  [
    {
      id: 'vacations',
      text: 'Vacations',
      icon: <Icon name="icon-plane" />,
      path: '/employee/vacations',
    },
    {
      id: 'expenses',
      text: 'Expenses',
      icon: <Icon name="icon-wallet" />,
      path: '/employee/expenses',
    },
    {
      id: 'colleagues',
      text: 'Colleagues',
      icon: <Icon name="icon-suitcase" />,
      path: '/employee/colleagues',
    },
  ],
  [
    {
      id: 'mobile-builds',
      text: 'Mobile Builds',
      icon: <Icon name="icon-mobile" />,
      path: '/employee/mobile-builds/',
    },
  ],
];
